import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { Attachment, type AttachmentConstructorData } from './Attachment'

export const AttachmentConstructorFactory =
  Factory.Sync.makeFactory<AttachmentConstructorData>({
    dateCreated: Factory.each(() => faker.date.recent().toISOString()),
    file: Factory.each(() => faker.random.uuid()),
    id: Factory.each(() => faker.random.number()),
    length: Factory.each(() => faker.random.number()),
    mimetype: Factory.each(() => faker.system.mimeType()),
    name: Factory.each(() => faker.random.words()),
    uuid: Factory.each(() => faker.random.uuid()),
  })

export const AttachmentFactory = EntityFactory(
  Attachment,
  AttachmentConstructorFactory
)
